<template>
    <div class="panorama-palette abs t-1 l-1 depth-4 f space-x-0.5">
        <div class="abs t-2.5 l-0 depth-4 f-col space-y-0.5">
            <!-- Share -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         permissions="project_images_edit"
                         tooltip="Поделиться"
                         tooltip-position="right"
                         el-icon="el-icon-share"
                         @click="share" />

            <!-- Edit (DISABLED) -->
            <plan-button v-if="false"
                         permissions="project_images_edit"
                         tooltip="Загрузить фотографию"
                         icon="upload-solid"
                         class="fill-white stroke-none "
                         @click="edit" />
        </div>
        <!-- Go back -->
        <plan-button tooltip="Назад"
                     icon="back"
                     @click="goBack" />

        <!-- Timeline -->
        <plan-button v-if="pointPhotosForTimeline.length"
                     :active="showTimeline"
                     tooltip="Timeline (beta)"
                     icon="timeline"
                     class="fill-white stroke-none"
                     @click="toggleTimeline" />

        <plan-button-group>
            <!-- Toggle split mode -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         :active="splitMode"
                         tooltip="Режим раздельного просмотра"
                         icon="split"
                         class="fill-white stroke-none"
                         @click="toggleSplitMode" />
    
            <!-- Toggle split sync -->
            <plan-button v-if="state === VIEW_MODE_TYPES.PANORAMA && splitMode"
                         :active="syncSplitMode"
                         :tooltip="syncSplitModeTooltip"
                         icon="compare"
                         :disabled="alignmentLoading"
                         @click="toggleSplitSync" />
        </plan-button-group>

        <plan-button v-if="state !== VIEW_MODE_TYPES.DULA && !planForTour"
                     permissions="project_tasks_defects_create"
                     :active="editing === VIEW_MODE_STATES.DEFECT"
                     icon="defect"
                     @click="toggleEditingByState(VIEW_MODE_STATES.DEFECT)">
            <span class="fs-0.8 _pl-0.5">
                Добавить предписание
            </span>
        </plan-button>

        <plan-button v-if="state !== VIEW_MODE_TYPES.DULA && !planForTour"
                     permissions="project_images_marking"
                     :active="editing === VIEW_MODE_STATES.EDIT"
                     icon="plus"
                     @click="toggleEditingByState(VIEW_MODE_STATES.EDIT)">
            <span class="fs-0.8 _pl-0.5">
                Добавить разметку
            </span>
        </plan-button>
  
        <!-- Toggle markup (DISABLED) -->
        <plan-button v-if="false && state !== VIEW_MODE_TYPES.DULA && state !== VIEW_MODE_TYPES.LABELBOX"
                     permissions="project_images_marking"
                     tooltip="Показать пользовательскую разметку"
                     icon="grid"
                     @click="toggleMarkup" />

        <!-- Save -->
        <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                     v-show="!isSaved"
                     :active="true"
                     label="Сохранить изменения"
                     @click="updateMeta" />
        
        <!-- DISABLED -->
        <plan-button-group v-if="false">
            <!-- To labelbox -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.LABELBOX"
                         tooltip="2D вид"
                         icon="image"
                         @click="setState(VIEW_MODE_TYPES.LABELBOX)" />
    
            <!-- To panorama -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.PANORAMA"
                         tooltip="3D вид"
                         icon="cube"
                         @click="setState(VIEW_MODE_TYPES.PANORAMA)" />
    
            <!-- Recognize -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         permissions="project_images_marking"
                         tooltip="Распознать картинку"
                         icon="visible"
                         @click="detect" />
    
            <!-- Delete -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         permissions="project_images_edit"
                         tooltip="Удалить выбранную мету"
                         icon="trash"
                         @click="deleteSelectedMark" />
        </plan-button-group>

        <plan-button-group v-if="planForTour">
            <!-- Transition point -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         :active="editing === VIEW_MODE_STATES.POINT"
                         permissions="project_images_3d_tour_marking"
                         tooltip="Добавить точку перехода"
                         icon="location"
                         @click="toggleEditingByState(VIEW_MODE_STATES.POINT)" />
    
            <!-- Annotation -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         :active="editing === VIEW_MODE_STATES.ANNOTATION"
                         permissions="project_images_3d_tour_marking"
                         tooltip="Добавить комментарий 3D тура"
                         icon="message"
                         @click="toggleEditingByState(VIEW_MODE_STATES.ANNOTATION)" />
    
            <!-- Camera anchor -->
            <plan-button v-if="state !== VIEW_MODE_TYPES.DULA"
                         :active="editing === VIEW_MODE_STATES.CAMERA_ANCHOR"
                         permissions="project_images_3d_tour_marking"
                         tooltip="Добавить точку направления камеры"
                         icon="camera"
                         @click="toggleEditingByState(VIEW_MODE_STATES.CAMERA_ANCHOR)" />
        </plan-button-group>

        <!-- Comment (DISABLED) -->
        <plan-button v-if="false"
                     :active="editing === VIEW_MODE_STATES.COMMENT"
                     permissions="project_comments_edit"
                     tooltip="Оставить комментарий"
                     icon="message"
                     @click="toggleEditingByState(VIEW_MODE_STATES.COMMENT)" />

        <!-- Gpr (DISABLED) -->
        <plan-button v-if="false && pointGprJobs.length"
                     :active="showGpr"
                     permissions="project_gpr_show"
                     tooltip="Показать данные ГПР"
                     icon="job"
                     @click="toggleGpr" />

        <!-- DISABLED -->
        <plan-button v-if="false && state !== VIEW_MODE_TYPES.DULA"
                     :active="syncSplitMode"
                     permissions="project_structure_edit"
                     tooltip="Список планируемых объектов"
                     icon="code"
                     @click="optionsPlanPoints" />
    </div>
</template>

<script>
import { resourceable } from '@/store/connectors'

import { VIEW_MODE_TYPES, STATES as VIEW_MODE_STATES } from '@/utils/viewer/view-mode'
import { MARK_TYPES } from '@/utils/viewer/marks'

import PlanButton from '@/components/map/PlanButton/PlanButton'
import PlanButtonGroup from '@/components/map/PlanButton/PlanButtonGroup'

export default {
  components: {
    PlanButton,
    PlanButtonGroup
  },
  mixins: [
    resourceable({ on: 'photos', name: 'alignment' })
  ],
  props: {
    loading: { type: Boolean, default: false },
    wrap: { type: Boolean, default: false },
    state: { type: String, default: null },
    isSaved: { type: Boolean, default: true },
    editing: { type: Number, default: 0 },
    splitMode: { type: Boolean, default: false },
    syncSplitMode: { type: Boolean, default: false },
    plan: { type: Object, default: null },
    pointGprJobs: { type: Array, default: () => [] },
    pointPhotosForTimeline: { type: Array, default: () => [] },
    showMarks: { type: Array, default: () => [] },
    showGpr: { type: Boolean, default: false },
    showTimeline: { type: Boolean, default: false }
  },
  data() {
    return {
      VIEW_MODE_TYPES,
      VIEW_MODE_STATES,
      MARK_TYPES
    }
  },
  computed: {
    planForTour() {
      return this.plan && !!this.plan.floor_plan_id
    },
    syncSplitModeTooltip() {
      return this.alignmentLoading ? 'Рассчитываем угол обзора': 'Режим синхронного просмотра'
    }
  },
  methods: {
    goBack() {
      this.$emit('go-back')
    },

    setState(state) {
      this.$emit('set-state', state)
    },

    toggleEditingByState(state) {
      this.$emit('toggle-editing-by-state', state)
    },

    toggleSplitMode() {
      this.$emit('toggle-split-mode')
    },

    toggleSplitSync() {
      this.$emit('toggle-split-sync')
    },

    toggleShowMark(mark) {
      this.$emit('toggle-show-mark', mark)
    },

    toggleGpr() {
      this.$emit('toggle-gpr')
    },

    toggleTimeline() {
      this.$emit('toggle-timeline')
    },

    detect() {
      this.$emit('detect')
    },

    edit() {
      this.$emit('edit')
    },

    updateMeta() {
      this.$emit('update-meta')
    },

    share() {
      this.$emit('share')
    },

    isShowMarks(markType) {
      return this.showMarks.indexOf(markType) !== -1;
    },

    optionsPlanPoints() {
      this.$emit('options-plan-points')
    },

    toggleMarkup() {
      this.$emit('toggle-markup')
    },

    deleteSelectedMark() {
      this.$emit('delete-selected-mark')
    },

    showBimViewer() {
      this.$emit('show-bim-viewer')
    }
  }
}
</script>

<style lang="scss">
.panorama-palette {
  .el-button {
    color: #FFFFFF;

    &:focus {
      color: #FFFFFF;
    }

    &:hover {
      color: #FFFFFF;
      background: #409EFF;
    }
  }
}
</style>
